/*
 * @Author: mikey.zhaopeng
 * @Date: 2021-07-05 17:04:31
 * @Last Modified by:   mikey.zhaopeng
 * @Last Modified time: 2021-07-05 17:04:31
 */

import { IYxInputPropTypes } from "./basePropType";
import PropTypes from "prop-types";
import { InputNumber } from "antd";
import React from "react";

export const numberPropTypes = {
  ...IYxInputPropTypes,

  //显示在前面的内容
  amountBeforeStr: PropTypes.string,

  //显示在后面的内容
  amountAfterStr: PropTypes.string,

  //是否开启四舍五入，在处理千分位和小数点时有效
  rounding: PropTypes.bool,

  //是否开启千分位处理
  thousand: PropTypes.bool,

  // 保留几位小数
  precision: PropTypes.number,

  // 最小值
  min: PropTypes.number,

  // 最大值
  max: PropTypes.number,
};

export const numberDefaultProps = () => ({
  children: <InputNumber />, //子节点
  rules: {
    max: "",
  },
  inputParam: {}, //存给input的参数
  amountBeforeStr: "", //显示在前面的前缀
  amountAfterStr: "", //显示在后面的后缀
  precision: 0, //保留几位小数
  thousand: true, //是否开启千分位处理
  max: 100000000, //最大数字
  min: -100000000, //最小数字
  styleParam: {
    width: "sm", //宽度  xxs,xs,sm,md,lg,xl
    size: "default", //大小
    type: "default", //类型
  },
});



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/IpropType/numberPropType.js